
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Fortuneronrentinpune() {



  const cardData =
  {
    keyword: 'Fortuner On Rent in Pune',
    heading: 'SHREE Tours & Travels: Fortuner On Rent in Pune ',
    headingDescription: 'SHREE Tours & Travels offers Fortuner on rent in Pune, providing a premium and powerful travel experience for luxury seekers, corporate executives and long-distance journeys. Whether you need a Cab for one-way travel, round trips, airport transfers, or weekend getaways, our well-maintained Toyota Fortuner ensures a smooth, comfortable and hassle-free ride. With professional drivers, ample luggage space and competitive pricing, we guarantee a top-class travel experience. Choose SHREE Tours & Travels for the best Fortuner rental service in Pune.',

    top: 'Top Places to Visit in Pune with SHREE Tours & Travels',
"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification built in 1732, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire. The fort is known for its grand entrance, intricate wooden carvings and the tragic fire that destroyed much of its structure in 1828. Visitors can explore the remnants of the palace, lush gardens and the famous 'Haunted Stories' that surround it. The light and sound show in the evening brings its history to life, making it a must-visit for history enthusiasts."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Aga Khan Palace is an architectural marvel built in 1892 by Sultan Muhammed Shah Aga Khan III. It played a significant role in India’s independence movement, as Mahatma Gandhi, his wife Kasturba Gandhi and his secretary Mahadev Desai were imprisoned here during the Quit India Movement. The palace is now a museum displaying rare photographs, personal belongings of Gandhi and an eternal flame that honors freedom fighters. Its serene gardens and Italian-style architecture make it a peaceful retreat for visitors."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Perched on a hilltop, Sinhagad Fort is a historic site that witnessed the famous battle of 1670 between the Marathas and the Mughals. The fort offers breathtaking panoramic views of the Sahyadri mountains and is a favorite trekking destination for adventure seekers. The trek is moderately challenging but rewarding, with small stalls along the way serving traditional Maharashtrian delicacies like pithla-bhakri, kanda bhaji and buttermilk. The monsoon season adds to its charm, making it an ideal getaway from Pune."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, the Pataleshwar Cave Temple is a hidden gem in Pune. Carved out of a single rock, the temple features massive pillars, intricate carvings and a Nandi (sacred bull) statue at the entrance. The sanctum houses a Shiva Linga and the surrounding caves add to its mystique. Despite being located in the bustling city, the temple exudes a peaceful aura, making it an ideal spot for meditation and spiritual seekers."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "A treasure trove of Indian heritage, the Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. The museum features an extensive collection of ancient musical instruments, traditional weapons, rare paintings and beautifully carved doors from different parts of India. A highlight is the 'Mastani Mahal,' a recreation of the palace of Bajirao’s beloved queen, Mastani. The museum offers a fascinating glimpse into India’s rich cultural past, making it a must-visit for art and history lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "An artificial lake built during the British era, Pashan Lake is a haven for nature lovers and birdwatchers. The lake is home to various migratory birds such as kingfishers, herons and egrets, making it a paradise for photographers. A well-maintained walking track surrounds the lake, providing a perfect setting for morning walks and jogging. The calm atmosphere and scenic beauty make it an ideal location for a relaxing day away from the city's hustle and bustle."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in the lush Koregaon Park, the Osho International Meditation Resort is one of the most famous spiritual centers in India. The ashram offers a wide range of meditation programs, wellness therapies and yoga sessions that attract visitors from around the world. Known for its unique blend of Eastern and Western spiritual practices, the resort provides a tranquil environment for those seeking inner peace and self-discovery. Visitors can also explore the beautifully landscaped gardens and the Osho Teerth Park nearby."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of Pune’s most revered temples, Dagdusheth Halwai Ganpati Temple is dedicated to Lord Ganesha. The temple is famous for its stunning idol adorned with gold and jewels, drawing thousands of devotees daily. It is especially vibrant during the Ganesh Chaturthi festival when the entire temple complex is beautifully decorated and grand celebrations take place. The spiritual aura and divine ambiance make it a must-visit for both pilgrims and tourists."
    },
    {
        "title": "Rajiv Gandhi Zoological Park",
        "description": "Spread over 130 acres, the Rajiv Gandhi Zoological Park is one of the largest zoos in Maharashtra. It consists of a zoo, a snake park and a wildlife rescue center. The park houses a variety of animals, including tigers, leopards, crocodiles and elephants. The snake park is a major attraction, featuring different species of snakes and reptiles. The well-maintained environment and informative exhibits make it a great place for families and wildlife enthusiasts."
    },
    {
        "title": "Khadakwasla Dam",
        "description": "Located on the Mutha River, Khadakwasla Dam is a popular weekend getaway spot for Pune residents. The dam provides water to the city and is surrounded by scenic hills and greenery. Visitors can enjoy stunning sunset views, go for long drives along the water, or indulge in delicious local snacks like vada pav and bhutta (roasted corn) sold by street vendors. The nearby Sinhagad Fort and Panshet Dam make it a perfect location for a one-day trip."
    }
],  
    
            
"services": [
    {
      "name": "Fortuner Car Rental Pune",
      "description": "Rent a Fortuner in Pune for a powerful and luxurious ride. Known for its rugged performance and premium interiors, it’s perfect for both city travel and outstation trips, ensuring comfort and style."
    },
    {
      "name": "Rent Fortuner in Pune",
      "description": "Book a Fortuner in Pune for any travel need. Whether it's for business, family, or group travel, enjoy a comfortable ride with ample space and modern features."
    },
    {
      "name": "Luxury Fortuner Hire Pune",
      "description": "Experience luxury with a Fortuner hire in Pune. This vehicle combines power and elegance, providing a smooth ride with premium features, ideal for both business and leisure trips."
    },
    {
      "name": "Fortuner for Outstation in Pune",
      "description": "Travel to outstation destinations with ease by renting a Fortuner from Pune. With its spacious interiors and robust performance, it's the perfect vehicle for long-distance travel."
    },
    {
      "name": "Affordable Fortuner Taxi Rental Pune",
      "description": "Looking for a budget-friendly yet premium ride? Rent an affordable Fortuner taxi in Pune, offering a balance of luxury, space and style without the high cost."
    },
    {
      "name": "Fortuner Hire for Group Travel Pune",
      "description": "Travel in comfort with a Fortuner for group travel in Pune. Its spacious interiors and powerful performance make it ideal for group outings, tours and more."
    },
    {
      "name": "Book Fortuner for Family Travel Pune",
      "description": "Plan a comfortable and memorable family trip by renting a Fortuner in Pune. With ample space for luggage and passengers, it’s the perfect choice for family vacations or long-distance travel."
    },
    {
      "name": "Fortuner for Corporate Travel Pune",
      "description": "For corporate trips, rent a Fortuner in Pune. With its executive feel and spacious interiors, it’s perfect for business meetings, client travel, or corporate retreats."
    },
    {
      "name": "Rent Fortuner for Business Trip Pune",
      "description": "Make your business trip more comfortable by renting a Fortuner in Pune. With ample space for work and relaxation, this vehicle is ideal for professionals traveling for meetings or conferences."
    },
    {
      "name": "Fortuner for Airport Pickup Pune",
      "description": "Book a Fortuner for a smooth and comfortable airport pickup in Pune. Enjoy a professional and timely service with a premium vehicle ensuring a comfortable ride to and from the airport."
    },
    {
      "name": "Book Fortuner for Pune to Outstation Trip",
      "description": "Rent a Fortuner for your outstation trips from Pune. Perfect for long journeys, this vehicle ensures comfort, ample space and reliable performance for your travel needs."
    },
    {
      "name": "Luxury Fortuner Hire for Group Events Pune",
      "description": "Hire a luxury Fortuner for group events in Pune. Whether for a wedding, corporate gathering, or special occasion, enjoy a stylish and spacious ride with premium features."
    },
    {
      "name": "Rent Fortuner for City Tour Pune",
      "description": "Explore Pune in style by renting a Fortuner for a city tour. With its spacious interiors and smooth performance, it’s the perfect vehicle for sightseeing and city exploration."
    }
  ],
  "tableData": [
    ["- Fortuner Car Rental Pune", "- Rent Fortuner in Pune"],
    ["- Luxury Fortuner Hire Pune", "- Fortuner for Outstation in Pune"],
    ["- Affordable Fortuner Taxi Rental Pune", "- Fortuner Hire for Group Travel Pune"],
    ["- Book Fortuner for Family Travel Pune", "- Fortuner for Corporate Travel Pune"],
    ["- Rent Fortuner for Business Trip Pune", "- Fortuner for Airport Pickup Pune"],
    ["- Book Fortuner for Pune to Outstation Trip", "- Luxury Fortuner Hire for Group Events Pune"],
    ["- Rent Fortuner for City Tour Pune"]
  ],

  whychoose: [
    {
      "WhyChooseheading": "Premium Comfort and Performance",
      "WhyChoosedescription": "The Toyota Fortuner offers a perfect blend of luxury and power, providing premium comfort, robust performance and stylish design. With its spacious interior, advanced features and powerful engine, the Fortuner ensures an exceptional travel experience for both short and long journeys in Pune."
    },
    {
      "WhyChooseheading": "Perfect for Family and Group Travel",
      "WhyChoosedescription": "With seating for up to 7 passengers, the Toyota Fortuner is ideal for families or groups. Whether you're planning a family vacation, a business trip, or a group getaway, this versatile vehicle provides ample space and comfort for everyone, ensuring an enjoyable ride throughout the journey."
    },
    {
      "WhyChooseheading": "Well-Maintained and Safe Vehicles",
      "WhyChoosedescription": "We ensure that all our Toyota Fortuner vehicles are carefully maintained and regularly serviced for optimal performance. Our vehicles undergo comprehensive inspections for cleanliness, safety and mechanical reliability, giving you peace of mind knowing you're traveling in a safe and well-maintained vehicle."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly experienced and professional, guaranteeing a smooth, safe and comfortable ride. They are familiar with the best routes around Pune and beyond and they focus on punctuality, safety and customer satisfaction, making your trip enjoyable and stress-free."
    },
    {
      "WhyChooseheading": "Ideal for Business and Leisure Travel",
      "WhyChoosedescription": "The Toyota Fortuner is perfect for both business and leisure travel. Whether you're attending a corporate meeting, traveling for a special event, or embarking on a family vacation, the Fortuner combines luxury and practicality to meet your needs."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking the Toyota Fortuner with SHREE Tours & Travels is quick and easy. You can make your reservation online via our user-friendly platform, or reach out to our customer service team for personalized assistance. We ensure a seamless and convenient booking experience."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for Fortuner rentals in Pune. Whether it's a last-minute booking or a planned trip, we’re ready to accommodate your travel needs at any time, day or night, ensuring you have access to a comfortable and reliable vehicle whenever you need it."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, we prioritize customer satisfaction. We are committed to providing exceptional service, ensuring that every Fortuner rental meets the highest standards of comfort, safety and reliability. Our goal is to provide you with a smooth and enjoyable experience from start to finish."
    }
  ]
  
  

  
  
  
  
  

  
  



        
  }
  const faqData = [
    {
        question: "How can I rent a Fortuner in Pune?",
        answer: "You can easily rent a Fortuner in Pune through our website or by contacting our customer service for assistance."
    },
    {
        question: "What is the rental rate for a Fortuner in Pune?",
        answer: "The rental rate for a Fortuner varies depending on the duration and type of trip. Please contact us for detailed pricing information."
    },
    {
        question: "Is the rental rate for the Fortuner inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. We provide detailed pricing information during the booking process."
    },
    {
        question: "Can I rent a Fortuner for a one-way trip in Pune?",
        answer: "Yes, we offer one-way rental options for the Fortuner for trips within Pune or to nearby cities."
    },
    {
        question: "Do you provide drivers with the Fortuner rental in Pune?",
        answer: "Yes, all our Fortuner rentals come with experienced drivers who are familiar with the local routes to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for Fortuner bookings in Pune?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for renting a Fortuner in Pune?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the Fortuner vehicles insured for safety during trips in Pune?",
        answer: "Yes, all our Fortuner vehicles are fully insured for your safety and peace of mind during the journey."
    },
    {
        question: "Can I request a child seat for my Fortuner rental in Pune?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for renting a Fortuner in Pune?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'I rented a Fortuner from SHREE Tours & Travels for a business trip in Pune. The vehicle was top-notch and the driver was very punctual and professional.',
        name: 'Mr. Pradeep Shah',
    },
    {
        text: 'Our family trip in Pune was amazing with the Fortuner from SHREE Tours & Travels. The car was spacious and comfortable and the driver was very courteous.',
        name: 'Miss. Neha Desai',
    }
];
















  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];

const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Rent a luxury Fortuner for your travel needs in Pune. Offering affordable and premium rental options for outstation trips, group travel, family trips, corporate travel and airport pickups. Call +91 9594917913 to book your Fortuner today!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411017",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/fortuner-rental-pune.jpg",
    "https://shreetoursandtravels.in/img/fortuner-group-travel.jpg"
  ],
  "priceRange": "₹15000 - ₹25000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/fortuner-rent-pune",
    "priceCurrency": "INR",
    "price": 20000,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.8,
    "reviewCount": 600
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Amit Deshmukh"
      },
      "datePublished": "2024-09-25",
      "reviewBody": "We rented a Fortuner for our family trip to Goa. The vehicle was in excellent condition, very comfortable and the driver was friendly. Highly recommend!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Ritu Yadav"
      },
      "datePublished": "2024-10-18",
      "reviewBody": "Booked a Fortuner for a corporate event. It was perfect for our group, very spacious and luxurious. Excellent service, will definitely use again!"
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Fortuner Rental in Pune",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 18.5204,  // Pune latitude
      "longitude": 73.8567  // Pune longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/fortuner-rent-pune"
  },
  "keywords": "Fortuner Car Rental Pune, Rent Fortuner in Pune, Luxury Fortuner Hire Pune, Fortuner for Outstation in Pune, Affordable Fortuner Taxi Rental Pune, Fortuner Hire for Group Travel Pune, Book Fortuner for Family Travel Pune, Fortuner for Corporate Travel Pune, Rent Fortuner for Business Trip Pune, Fortuner for Airport Pickup Pune, Book Fortuner for Pune to Outstation Trip, Luxury Fortuner Hire for Group Events Pune, Rent Fortuner for City Tour Pune"
};


  return (
    <div>
    <GoogleAnalytics/>
<Helmet>
  <title>Fortuner on Rent in Pune | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Rent a luxury Fortuner for your travel needs in Pune. Offering affordable and premium rental options for outstation trips, group travel, family trips, corporate travel and airport pickups. Call +91 9594917913 to book your Fortuner today!" />
  <meta name="keywords" content="Fortuner Car Rental Pune, Rent Fortuner in Pune, Luxury Fortuner Hire Pune, Fortuner for Outstation in Pune, Affordable Fortuner Taxi Rental Pune, Fortuner Hire for Group Travel Pune, Book Fortuner for Family Travel Pune, Fortuner for Corporate Travel Pune, Rent Fortuner for Business Trip Pune, Fortuner for Airport Pickup Pune, Book Fortuner for Pune to Outstation Trip, Luxury Fortuner Hire for Group Events Pune, Rent Fortuner for City Tour Pune" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>


    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/29.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Fortuneronrentinpune;